export const ru = {
    action_submit: 'Назначить',
    grant_to: 'Сотрудника',
    title: 'Назначить координатором',
};
